export const BRAND_NAME = 'PlayNetGaming';
// Note: It is the main site url. Ex - PlayNetGaming.com, etc.
export const BRAND_DOMAIN = 'playnetgaming.net';
// Note: It is the main site url. Ex - playnetgaming.net, etc.
export const BRAND_DOMAIN_SKIN_URL = 'playnetgaming.net';
export const PROVIDER = 'BetFair';
export const PROVIDER_ID = 'BetFair';
export const BACKEND_DOMAIN = 'cue88.com';